import { render, staticRenderFns } from "./Advance.vue?vue&type=template&id=161ace27&"
import script from "./Advance.vue?vue&type=script&lang=js&"
export * from "./Advance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports